/*******************************************************************************
 * Copyright (c) 2024 Passport Fintech Inc. All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 ******************************************************************************/

export interface UserInvitationAcceptanceAPIPayload {
  first_name: string;
  last_name: string;
  email: string;
  password: string;
  otp: string;
  account_id: string;
}

export interface UserInvitationAcceptance {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  otp: string;
  accountId: string;
}

/**
 * This method transforms the UserInvitationAcceptance into the API payload
 * @param user - UserInvitationAcceptance
 * @returns UserInvitationAcceptancePIPayload
 */
export const userInvitationAcceptanceToAPIPayload = (
  user: UserInvitationAcceptance
): UserInvitationAcceptanceAPIPayload => {
  return {
    first_name: user.firstName,
    last_name: user.lastName,
    email: user.email,
    password: user.password,
    otp: user.otp,
    account_id: user.accountId,
  };
};
